import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

// Is this device already subscribed to push? Used to show "Alerts on" on load.
// Also self-heals: re-registers the existing subscription with the server so the
// server-side record can't drift out of sync with the browser (which would make
// the toggle show "on" while no notifications actually get delivered).
export async function checkPushEnabled() {
  if (!pushSupported()) return false;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return false;
    const sub = await reg.pushManager.getSubscription();
    if (!sub || Notification.permission !== "granted") return false;
    try { await api.pushSubscribe(sub.toJSON()); } catch { /* best-effort resync */ }
    return true;
  } catch { return false; }
}

// Subscribe this device to web-push job alerts. Requires the PWA service worker
// (production build) + user granting notification permission. Returns a status
// string so the UI can give clear feedback.
export async function enablePushAlerts() {
  if (!pushSupported()) return "unsupported";
  const reg = await navigator.serviceWorker.getRegistration();
  if (!reg) return "no-sw"; // service worker only registers in the deployed build
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return "denied";
  try {
    const key = await api.vapidKey();
    if (!key) return "unsupported";
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(key),
      });
    }
    await api.pushSubscribe(sub.toJSON());
    return "enabled";
  } catch {
    return "error";
  }
}
